import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ParamHandlingService {
  private queryParams: {[key:string]: string} = {};
  private utmQueryParams: {[key:string]: string} = {};
  private utmParamStr: string;
  constructor() {
    this.utmParamStr = '';
   }
  addQueryParamToObj(qp, value) {
    if(value) {
      this.queryParams[qp] = value;
    }
  }
  getUtmQueryParamStr(){
    this.utmParamStr = '';
    for (const [key, value] of Object.entries(this.queryParams)) {
      if(key.indexOf('utm_') > -1) {
        this.utmParamStr+= `${key}=${value}&`;
      }
    }
    return this.utmParamStr.slice(0, -1);
  }
  getUtmQueryParams(){
    for (const [key, value] of Object.entries(this.queryParams)) {
      if(key.indexOf('utm_') > -1) {
        this.utmQueryParams[key] = value;
      }
    }
    return this.utmQueryParams;
  }

}
